
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M1.5 4.5h37v31h-37z"}}),_c('path',{attrs:{"fill":"#DFF0FE","d":"M1.5 10H7v25.5H1.5zM20 10h5v25.5h-5z"}}),_c('path',{attrs:{"fill":"#98CCFD","d":"M1.5 4.5h37L39 10H2z"}}),_c('path',{attrs:{"d":"M35.5 32h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM33.5 23h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zM35.5 19h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM35.5 15h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM35.5 28h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zM17.5 32h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM17.5 23h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM14.5 19h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM17.5 15h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM17.5 28h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1z","fill":"#4788C7"}}),_c('path',{attrs:{"d":"M38 5v30H2V5h36m1-1H1v32h38V4z","fill":"#4788C7"}}),_c('path',{attrs:{"fill":"#4788C7","d":"M1 4v7h1V5h36v6h1V4z"}}),_c('circle',{attrs:{"cx":"4.5","cy":"14.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"4.5","cy":"18.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"4.5","cy":"22.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"4.5","cy":"27.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"4.5","cy":"31.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"22.5","cy":"14.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"22.5","cy":"18.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"22.5","cy":"27.5","r":".5","fill":"#4788C7"}}),_c('circle',{attrs:{"cx":"22.5","cy":"31.5","r":".5","fill":"#4788C7"}})])
          )
        }
      }
    